import { SimpleProductItem } from 'lib/core/data/quote/addProduct/types'
import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface AddSimpleProductToCartMutationObject {
  mutation: {
    addSimpleProductsToCart: {
      __args: {
        input: {
          cart_id: string
          cart_items: Record<string, any>
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const addSimpleProductToCartMutationObject: AddSimpleProductToCartMutationObject = {
  mutation: {
    addSimpleProductsToCart: {
      __args: {
        input: {
          cart_id: '',
          cart_items: []
        }
      }
    }
  }
}

interface AddSimpleProductToCartMutationInput {
  cartId: string
  cartItems: SimpleProductItem[]
}

export type AddSimpleProductToCartMutation = (input: AddSimpleProductToCartMutationInput) => Promise<FetchResult<any>>

interface Items {
  data: {
    quantity: number
    sku: string
  }
  customizable_options?: Array<{
    id: number
    value_string: string
  }>
}

export const createAddSimpleProductToCartMutation = ({ getMutations, getQueries }: ServiceDependencies): AddSimpleProductToCartMutation => async ({ cartId, cartItems }) => {
  const queries = getQueries()
  const items = cartItems.map((item) => {
    const {
      quantity,
      sku,
      customizableOptions,
      ...rest
    } = item

    const hasCustomOptions = customizableOptions?.length

    const data: Items = {
      data: {
        ...rest,
        quantity,
        sku
      }
    }

    if (hasCustomOptions) {
      data.customizable_options = customizableOptions?.map(({ id, value_string: valueString }) => {
        return {
          id,
          value_string: valueString
        }
      })
    }

    return data
  })

  const mutation = getMutations().addSimpleProductToCartMutation
  mutation.mutation.addSimpleProductsToCart.__args.input.cart_id = cartId
  mutation.mutation.addSimpleProductsToCart.__args.input.cart_items = items
  mutation.mutation.addSimpleProductsToCart = {
    ...mutation.mutation.addSimpleProductsToCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
